import { Skeleton } from '@kiwicom/orbit-components';
import { useIntl } from 'react-intl';

const PastTripsPlaceholder = (): JSX.Element => {
  const intl = useIntl();
  return (
    <Skeleton
      width="100%"
      height={225}
      dataTest="PastTripsPlaceholder"
      title={intl.formatMessage({
        id: 'common.loading',
        defaultMessage: 'Loading',
      })}
    >
      <rect x="0" y="0" height="225" width="33%" />
      <rect x="315" y="0" height="225" width="33%" />
      <rect x="630" y="0" height="225" width="33%" />
    </Skeleton>
  );
};

export default PastTripsPlaceholder;
